import React from 'react'
import Navbar from '../Navbar'
import AdminSidebar from './AdminSidebar'

/**
 * AdminLayout - Layout wrapper for admin pages
 *
 * Includes dark-themed sidebar with admin navigation
 */
const AdminLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900">
      <Navbar />
      <div className="flex pt-16">
        <AdminSidebar />
        <main className="flex-1 ml-64 p-6">
          <div className="max-w-7xl mx-auto">
            {children}
          </div>
        </main>
      </div>
    </div>
  )
}

export default AdminLayout
